var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M20 12a1 1 0 011 1v6.5a3.5 3.5 0 01-6.176 2.255L14.7 21.6l-.056-.085a1 1 0 011.59-1.195l.066.079.11.13A1.5 1.5 0 0019 19.5v-.836a3.5 3.5 0 11.18-6.234 1 1 0 01.82-.43zm-2.5 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-2.475-5.44a1 1 0 011.338-.067l.076.068.11.099a1.503 1.503 0 001.525.226 1.5 1.5 0 00.486-.325l.077-.068a1 1 0 011.407 1.406l-.07.076a3.5 3.5 0 01-4.824.12l-.125-.12-.068-.076a1 1 0 01.068-1.338z",
          fill: "#2C3143",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12 13c0 2.761-1.239 5-4 5s-4-2.239-4-5 1.239-5 4-5 4 2.239 4 5z",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("circle", { attrs: { cx: "6", cy: "5", r: "1", fill: "#2C3143" } }),
      _c("circle", { attrs: { cx: "10", cy: "5", r: "1", fill: "#2C3143" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }